import "@formatjs/intl-datetimeformat/polyfill-force";
import "@formatjs/intl-datetimeformat/locale-data/en";
import "@formatjs/intl-datetimeformat/locale-data/es";
import "@formatjs/intl-datetimeformat/locale-data/ar";
import "@formatjs/intl-datetimeformat/locale-data/pt";
import "@formatjs/intl-datetimeformat/locale-data/ka";
import "@formatjs/intl-datetimeformat/locale-data/nl";

import app from "./bootstrap";

app().then((app) => {
  app.mount("#track-and-trace");
});
